/**
 * TR biçimli sayı hücresi: binlik ayıracı nokta, ondalık ayıracı virgül ("1.234,00", "-312,30", "42").
 * Para birimi kodu ya da metin bu kalıba uymaz.
 */
const NUMERIC_CELL = /^-?\d{1,3}(\.\d{3})*(,\d+)?$|^-?\d+(,\d+)?$/

/**
 * Bir kolonun tamamı sayısal mı? Tutar kolonları sağa yaslanınca basamaklar hizalanır ve tablo
 * okunur hale gelir. Boş hücre kolonu diskalifiye etmez (veri eksik olabilir), ama tamamı boş
 * kolon sayısal sayılmaz — aksi halde boş metin kolonları da sağa kayardı.
 */
export function isNumericColumn(cells: string[]): boolean {
  const filled = cells.filter(cell => cell.trim().length > 0)
  return filled.length > 0 && filled.every(cell => NUMERIC_CELL.test(cell.trim()))
}
